import BaseModel from "./BaseModel";

export default class NotificationMessage extends BaseModel {

	static entity = 'notification_messages';
	static route = 'notification-messages';
	static plural = 'notification_messages';
	static singular = 'notification_message';

	static fields () {
		return {
			id: this.attr(null),
			message: this.attr(null),
			type: this.attr(null),
			model_type: this.attr(null),
			model_id: this.attr(null),
			filter_value: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
		}
	}

	static get generalNotification() {
		return 'App\\Notifications\\GeneralNotification';
	}

	static get orderStatusChanged() {
		return 'App\\Notifications\\OrderStatusChanged';
	}

	static get estimateStatusChanged() {
		return 'App\\Notifications\\EstimateStatusChanged';
	}

	static get orderStatusFilters() {
		return ['Pending', 'Cancelled', 'Processed', 'On Hold', 'Scheduled', 'Partially Completed', 'Completed', 'Shipped', 'Closed'];
	}

}
